//Components
import React, { useState, useEffect } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'
import { useParams, useNavigate } from 'react-router-dom';
import { Header } from '../common/Header/Header'
//Utils
import { RenderIf } from '../../utils/RenderIf';
//API
import { OrdersFetchAPI } from '../../api/Orders';
import { BusinessFetchAPI } from '../../api/Business';
import { DgiFetchAPI } from '../../api/Dgi';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
//img
import logo_sp from '../img/logos/logo.png';
import './cart.css';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';

const OrderPending = () => {
  const navigate = useNavigate();
  //State for show modal
  const [show, setShow] = useState(false);
  const [formatVoucher, setformatVoucher] = useState("");
  const [modalShowVoucher, setmodalShowVoucher] = useState(false)
  //State order data 
  const { order_code } = useParams();

  const [business_code, setbusiness_code] = useState(() => {
    if (localStorage.getItem("business") != "" && localStorage.getItem("business") != undefined) {
      return JSON.parse(localStorage.getItem("business")).code
    }
  });
  const [branchoffice_code, setBranchOfficeCode] = useState(() => {
    if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined) {
      return JSON.parse(localStorage.getItem("branchoffice")).code
    }
  });
  const [orderData, setOrderData] = useState({
    createdAt: "2023-07-25T10:02:35.000+00:00",
    cufe: "0",
    dgi_qr: "0"

  });
  const [cardsItems, setCardItems] = useState([]);
  const [businessData, setBusinessData] = useState({
    name: ''
  });
  const [branchOfficeData, setBranchofficeData] = useState({
    "ruc": "",
    "dv": "",
    "name": "",
    "ruc_type": "",
    "direction": "",
    "dgi_name": "",
  });

  //Function to get a temporal order data by code
  const getTemporalOrderByCode = async (code) => {
    try {
      let token = undefined;
      const response = await OrdersFetchAPI.getTempOrderByCode(code, business_code, branchoffice_code, token);
      //console.log(response);
      return response;
    } catch (err) {
      //console.log(err);
    }
  }

  // function convert format voucher
  const formatVoucherString = () => {
    //console.log("orderData", orderData);
    let voucher = orderData.voucher
    // Extraer el número de tarjeta ocultando los dígitos intermedios
    const maskedVoucher = voucher.replace(/(\d{6})\d+(\d{4})/g, "$1XXXXXX$2");

    // Construir el string formateado del voucher
    const formattedVoucher = `${maskedVoucher}`;
    setformatVoucher(formattedVoucher)
    //return formattedVoucher;
  };

  const handleViewCoucher = () => {
    formatVoucherString()
    setmodalShowVoucher(true)
  }

  //We get the page data 
  useEffect(() => {
    (async () => {
      try {
        //console.log("order_code", order_code);
        const response = await getTemporalOrderByCode(order_code);
        //console.log(response);
        setOrderData(response.data.order);
        setCardItems(response.data.order.groups);
        //We get the business
        const response_business = await BusinessFetchAPI.getBusinessByCode(response.data.order.business.code)
        //We set the business data 
        setBusinessData(response_business.data.business)
        //We get the branchoffice info 
        const response_branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(response.data.order.business.code, response.data.order.branchoffice.code);
        //We set the business data 
        setBranchofficeData(response_branch.data.branchoffice);
      } catch (err) {
        //console.log(err)
      }
    })()
  }, []);

  //We charge the items of the order
  const orderItems = () => {
    let items = cardsItems.map((options) => (
      <div className="d-flex text-muted pt-3 px-xs-2" key={options._id}>
        <img className="bd-placeholder-img flex-shrink-0 me-2 rounded" src={buildCloudinaryImageUrl({ url: options.img, width: 300, quality: "auto", type: "image" }) || undefined} width="42" height="42" />
        <div className="pb-3 mb-0  lh-sm  w-100">
          <div className="d-flex justify-content-between ">
            {/* Name */}
            <span className="text-dark fw-bold">{options.name}</span>
            {/* Cantidad/ Quantity*/}
            <div>
              <span className='px-3'>x{options.amount} </span>
              <label className="fw-bold" >{options.price.toFixed(2)}</label>
            </div>

          </div>
          {/** Segment items */}
          <>
            <div className="d-flex justify-content-between">
              {/* Name */}
              <span className="">Descuento</span>
              {/* Cantidad/ Quantity*/}
              <div>
                <label className={options.discount === undefined ? "" : "text-danger"}>{options.discount === undefined ? "No registrado" : "- $" + options.discount.toFixed(2)}</label>
              </div>
            </div>
            {options.segments.map((segments) => (
              <div className="d-flex justify-content-between">
                {/* item name */}
                <span className="">{segments.item.name}</span>
              </div>
            ))}
          </>
        </div>
      </div>
    ))
    return <> {items}</>
  }

  return (
    <>

      <section className=' d-lg-flex justify-content-lg-center container-lg container-flui'>
        <div className='ecomerce-container-1 position-realtive mx-0 pb-2'>
          <Header></Header>
          <main className='main-invoice-sp'>
            <Container className='mb-2 '>
              <div className='d-flex justify-content-between py-1'>
                <h1 className='h2'>Su pago esta pendiente de aprobación </h1>
              </div>

              <div>
                <h5 className='border p-2 rounded shadow-sm'>
                  <span className="text-secondary">NOTA: </span>
                  <span className="text-danger">Este comercio no acepta pagos pendientes de aprobacion, en 24 horas si el pago se aprueba se realizara un reembolso automatico.</span>
                </h5>

              </div>

              {/* Your card */}
              <Row>
                <Col sm={12} md={12}  >
                  <div className="py-4 px-lg-4 zigzag ">
                    <div className="head-section-sp mt-2 p-3">
                      <div className="">
                        <div className="mt-1 mb-3">
                          <div className="d-flex justify-content-between align-items-center mb-3 ">
                            <div className='header-invoice'>
                              <div>
                                <h4 className='bussines-donlee'>{businessData.name}</h4>
                              </div>
                            </div>

                            <h5>
                              <span className="text-success">Orden: </span>
                              <span className=""> #{orderData.code}</span>
                            </h5>

                          </div>
                        </div>
                      </div>


                      <div className=' d-flex justify-content-between text-secondary opacity-75'>
                        <div> Productos </div>
                        <div> Precio </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 col-lg-12 order-md-last">
                          {/* Item cards */}
                          {orderItems()}
                          <div className="d-flex text-muted pt-3">

                            <div className="pb-3 mb-0 small lh-sm border-top w-100">
                              <div className="d-flex justify-content-end mt-3">
                                <span className="text-gray-dark fw-light h6"> Descuento: </span>
                                <span className='text-danger fw-light h6'>
                                  <span className='px-2 '>- $</span>
                                  {typeof orderData.subtotal === 'number' ? orderData.discount.toFixed(2) : orderData.discount}
                                </span>
                              </div>
                              <div className="d-flex justify-content-end mt-3">
                                <span className="text-gray-dark fw-light h6"> Subtotal: </span>
                                <span className='text-black fw-light h6'>
                                  <span className='px-2 '>$</span>
                                  {typeof orderData.subtotal === 'number' ? orderData.subtotal.toFixed(2) : orderData.subtotal}
                                </span>
                              </div>
                              <div className="d-flex justify-content-end mt-3">
                                <span className="text-gray-dark fw-light h6"> Itbms: </span>
                                <span className='text-black fw-light h6'>
                                  <span className='px-2 '>$</span>
                                  {typeof orderData.tax === 'number' ? orderData.tax.toFixed(2) : orderData.tax}</span>
                              </div>
                              <div className="d-flex justify-content-end mt-3">
                                <strong className="text-black h5"> Total: </strong>
                                <span className='text-black fw-bold h5'>
                                  <span className='px-2 '>$</span>
                                  {typeof orderData.total === 'number' ? orderData.total.toFixed(2) : orderData.total}</span>
                              </div>

                              {orderData.voucher_response !== "0" && orderData.voucher_response !== 0 ? <>
                                <div className='d-flex justify-content-end mt-3'>
                                  <Button className='m-2' onClick={() => (handleViewCoucher())}><i className="uil uil-receipt-alt"></i> Voucher de transaccion</Button>
                                </div></> : <></>}


                              <div className='d-flex justify-content-center mt-3'>
                                <Button className='m-2' variant="outline-primary" onClick={() => (navigate(`/home`))}><i class="uil uil-estate">Inicio</i> </Button>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>

            <Modal
              show={modalShowVoucher}
              onHide={() => setmodalShowVoucher(false)}
              size='lg'
              centered>
              <Modal.Header>
                Voucher de transaccion: #{orderData.transaction_code}
              </Modal.Header>
              <Modal.Body>
                <div className='d-flex alight-item-center justify-content-center'>
                  <div>
                    <pre>{formatVoucher}</pre>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={() => (setmodalShowVoucher(false))}>Cerrar</Button>
              </Modal.Footer>
            </Modal>
          </main >

        </div>
      </section>
    </>
  )
}

export default OrderPending;